export const TIMEFRAMES = [
  "1d",
  "3d",
  "7d",
  "15d",
  "30d",
  "3m",
];

/** Map timeframe string to number of days (calendar-day window) */
export const TIMEFRAME_TO_DAYS = {
  "1d": 1,
  "3d": 3,
  "7d": 7,
  "15d": 15,
  "30d": 30,
  "3m": 90,
};

/** Map timeframe string to hours */
export const timeframeToHours = (tf) => {
  const map = {
    "1h": 1,
    "4h": 4,
    "12h": 12,
    "1d": 24,
    "3d": 72,
    "7d": 168,
    "15d": 360,
    "30d": 720,
    "3m": 2160,
  };
  return map[tf];
};

/** Timeframe display label */
export const timeframeLabel = (tf) => {
  const map = {
    "1h": "1h",
    "4h": "4h",
    "12h": "12h",
    "1d": "1d",
    "3d": "3d",
    "7d": "7d",
    "15d": "15d",
    "30d": "30d",
    "3m": "3m",
  };
  return map[tf];
};

/** Interpolate inflow/outflow for an arbitrary timeframe using available data points */
const interpolateFlow = (flow, hours) => {
  if (hours <= 1) return flow["1h"] * hours;
  if (hours <= 4) return flow["1h"] * hours;
  if (hours <= 24) {
    const rate = flow["24h"] / 24;
    return rate * hours;
  }
  const rate = flow["1w"] / 168;
  return rate * hours;
};

/** Compute all timeframe-dependent metrics for a single connector-currency */
export const computeTimeframeMetrics = (c, tf) => {
  const hours = timeframeToHours(tf);
  const inflow = interpolateFlow(c.inflow, hours);
  const outflow = interpolateFlow(c.outflow, hours);
  const netFlow = inflow - outflow;
  const ratePerHour = hours > 0 ? netFlow / hours : 0;
  const projectedBalance = c.balance + ratePerHour * hours;

  let depletionHours;
  if (c.isNegative) {
    depletionHours = 0;
  } else if (ratePerHour < 0) {
    depletionHours =
      Math.round((c.balance / Math.abs(ratePerHour)) * 10) / 10;
  }

  const projected48 = c.balance + ratePerHour * 48;
  const topUp48h = projected48 < 0 ? Math.abs(projected48) : 0;

  return {
    inflow,
    outflow,
    netFlow,
    ratePerHour,
    projectedBalance,
    depletionHours,
    topUp48h,
  };
};

/** Risk probability based on timeframe metrics */
export const computeRiskProbability = (m) => {
  if (m.depletionHours !== undefined && m.depletionHours <= 24) return "high";
  if (m.depletionHours !== undefined && m.depletionHours <= 72)
    return "medium";
  if (m.ratePerHour < 0) return "medium";
  return "low";
};
